<template>
  <span
    @mouseover="hovered = true"
    @mouseleave="hovered = false"
    class="CustomInputFour"
  >
    <label class="formLabel">
      {{ name }}
    </label>
    <input
      class="uppercase py-2 px-4 block w-full appearance-none leading-normal border placeholder-black placeholder-opacity-100"
      :class="{
        'bg-gray-100 border-black': disabled,
        'bg-white':!disabled&&!hovered,
        'bg-white font-semibold':!disabled&&hovered,
        'border-red-500 ':error,
        'border-black':!error
      }"
      :type="type"
      :placeholder="placeholder"
      :disabled="disabled"
      :value="value"
      @input="updateValue($event.target.value)"
      @keypress="checkType($event)"
    >
  </span>
</template>

<script>
export default {
  name: 'CustomInputFour',
  props: {
    name: String,
    value: [String, Number],
    type: String,
    placeholder: String,
    disabled: {
      type: Boolean,
      default: false
    },
    error: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      hovered: false
    }
  },
  methods: {
    updateValue (value) {
      this.$emit('input', value)
    },
    checkType (evt) {
      if (this.type === 'number') {
        var charCode = (evt.which) ? evt.which : evt.keyCode
        if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
          evt.preventDefault()
        } else {
          return true
        }
      }
    }
  }
}
</script>

<style lang="scss">
  // hide the number arrows
  .CustomInputFour
  {
    /* Chrome, Safari, Edge, Opera */
    input[type=number]::-webkit-inner-spin-button,
    input[type=number]::-webkit-outer-spin-button {
      -webkit-appearance: none;
      margin: 0;
    }

    /* Firefox */
    input[type=number] {
      -moz-appearance: textfield;
    }
  }
</style>
